import moment from "moment-timezone"

export const showDateAndTime = (datetime: string) => moment(datetime).format("DD.MM.YYYY HH:mm")